const shopNavDefault = {
  listItemAccount: false,
  listItemWine: true,
  listItemCoffee: false,
  listItemGifts: false,
  listItemOnehope: false,
  listItemCollection: false,
  listItemGlitter: false,
  listItemKitchen: false,
  listItemGuides: false,
  listItemTea: false,
};

export const closeAllListItems = () => {
  Object.keys(shopNavDefault).forEach(key => {
    shopNavDefault[key] = false;
  });
  return shopNavDefault;
};

const assignToShopNavDefault = newShopNav => {
  Object.keys(newShopNav).forEach(key => {
    shopNavDefault[key] = newShopNav[key];
  });
  return shopNavDefault;
};

export const openListItem = val => {
  // Click on a nested item, make sure containing lists stay open.
  closeAllListItems();
  switch (val) {
    case 'account': // Accounts
      shopNavDefault.listItemAccount = true;
      break;
    case 'wine': // Wines
      shopNavDefault.listItemWine = true;
      break;
    case 'collection': // Collections
      shopNavDefault.listItemWine = true;
      shopNavDefault.listItemCollection = true;
      break;
    case 'glitter': // Glitter
      shopNavDefault.listItemWine = true;
      shopNavDefault.listItemCollection = true;
      shopNavDefault.listItemGlitter = true;
      break;
    case 'gift': // Gifts
      shopNavDefault.listItemGifts = true;
      break;
    case 'guide': // Gift Guides
      shopNavDefault.listItemGifts = true;
      shopNavDefault.listItemGuides = true;
      break;
    case 'coffee': // Coffee
      shopNavDefault.listItemCoffee = true;
      break;
    case 'kitchen': // Kitchen
      shopNavDefault.listItemKitchen = true;
      break;
    // case 'tea': // Tea
    //   shopNavDefault.listItemTea = true;
    //   break;
    case 'onehope': // ONEHOPE
      shopNavDefault.listItemOnehope = true;
      break;
    default:
      break;
  }
  return shopNavDefault;
};

export const defaultByPath = pathname => {
  closeAllListItems();
  switch (true) {
    case pathname.includes('glitter'): // Evaluated before collection
      shopNavDefault.listItemWine = true;
      shopNavDefault.listItemCollection = true;
      shopNavDefault.listItemGlitter = true;
      break;
    case pathname.includes('collection'): // Evaluated before Wine
      shopNavDefault.listItemWine = true;
      shopNavDefault.listItemCollection = true;
      break;
    case pathname.includes('guide'):
      shopNavDefault.listItemGifts = true;
      shopNavDefault.listItemGuides = true;
      break;
    case pathname.includes('gifts'):
      shopNavDefault.listItemGifts = true;
      break;
    case pathname.includes('coffee'):
      shopNavDefault.listItemCoffee = true;
      break;
    case pathname.includes('kitchen'):
      shopNavDefault.listItemKitchen = true;
      break;
    // case pathname.includes('tea'):
    //   shopNavDefault.listItemTea = true;
    //   break;
    case pathname.includes('corporate'):
    case pathname.includes('weddings'):
      // Don't open anything for weddings.
      break;
    case pathname.includes('wine'):
    case pathname.includes('thanksgiving'): // Thanksgiving special page
    case pathname.includes('black-friday'): // Black Friday special page
    default:
      shopNavDefault.listItemWine = true;
      break;
  }
  return shopNavDefault;
};

export const toggleListItem = val => {
  // Every property will be set to False, unless assigned in the switch statement.
  const newShopNavVals = {};
  switch (val) {
    case 'account': // Accounts
      newShopNavVals.listItemAccount = !shopNavDefault.listItemAccount;
      break;
    case 'wine': // Wines
      newShopNavVals.listItemWine = !shopNavDefault.listItemWine;
      // Don't force close Collections when toggling wines category; keep same value.
      newShopNavVals.listItemCollection = shopNavDefault.listItemCollection;
      break;
    case 'collection': // Collections
      newShopNavVals.listItemWine = true;
      newShopNavVals.listItemCollection = !shopNavDefault.listItemCollection;
      break;
    case 'glitter': // Glitter
      newShopNavVals.listItemWine = true;
      newShopNavVals.listItemCollection = true;
      newShopNavVals.listItemGlitter = true;
      break;
    case 'gift': // Gifts
      newShopNavVals.listItemGifts = !shopNavDefault.listItemGifts;
      // Don't force close Guides when toggling gifts category; keep the same value.
      newShopNavVals.listItemGuides = shopNavDefault.listItemGuides;
      break;
    case 'guide': // Gift Guides
      newShopNavVals.listItemGifts = true;
      newShopNavVals.listItemGuides = !shopNavDefault.listItemGuides;
      break;
    case 'coffee': // Coffee
      newShopNavVals.listItemCoffee = !shopNavDefault.listItemCoffee;
      break;
    case 'kitchen': // Kitchen
      newShopNavVals.listItemKitchen = !shopNavDefault.listItemKitchen;
      break;
    case 'onehope': // ONEHOPE
      newShopNavVals.listItemOnehope = !shopNavDefault.listItemOnehope;
      break;
    // case 'tea': // tea
    //   newShopNavVals.listItemTea = !shopNavDefault.listItemTea;
    //   break;
    default:
      break;
  }

  // After determining the new values, clear the .
  closeAllListItems();
  assignToShopNavDefault(newShopNavVals);
  return shopNavDefault;
};
